export class Type {
	id: number;
	name: string;
	price: number;
	order: number;
	labelDisplay: string;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/Type.ts